module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mentor-profile-editor"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.working),
      expression: "working"
    }],
    staticClass: "working"
  }, [_vm._m(0)]), _vm._v(" "), (_vm.profile) ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updateProfile()
      }
    }
  }, [_c('h4', {
    staticClass: "bump"
  }, [_vm._v("General Information")]), _vm._v("\n                I work for "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.profile.company),
      expression: "profile.company",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.profile.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.company = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n                company's URL "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.profile.companyUrl),
      expression: "profile.companyUrl",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "required": "",
      "placeholder": "http://etc"
    },
    domProps: {
      "value": (_vm.profile.companyUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.companyUrl = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('br'), _vm._v("\n                And my current position/title is "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.profile.position),
      expression: "profile.position",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.profile.position)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.position = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('br'), _vm._v("\n                Living in "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.profile.location),
      expression: "profile.location",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.profile.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.location = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n                the industry I work in is\n                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.industry),
      expression: "profile.industry"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.industry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vfx"
    }
  }, [_vm._v("VFX / Film & TV")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video_games"
    }
  }, [_vm._v("Video Game & VR / AR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("Both VFX and Games")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                I am currently\n                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.status),
      expression: "profile.status"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unconfirmed"
    }
  }, [_vm._v("Unconfirmed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "available"
    }
  }, [_vm._v("Available")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unavailable"
    }
  }, [_vm._v("Unavailable")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "archive/hidden"
    }
  }, [_vm._v("Archive/Hidden")])]), _vm._v("\n                to mentor\n                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.seats),
      expression: "profile.seats"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.seats = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")])]), _vm._v("\n                student(s)\n                "), _c('br'), _c('br'), _vm._v("\n                I'd like to connect with my mentees on the\n                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.availableDays),
      expression: "profile.availableDays"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.availableDays = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekdays"
    }
  }, [_vm._v("week days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekends"
    }
  }, [_vm._v("weekends")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("any time of the week")])]), _vm._v("\n                during\n                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.availableTimes),
      expression: "profile.availableTimes"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.availableTimes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mornings"
    }
  }, [_vm._v("mornings")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "afternoons"
    }
  }, [_vm._v("afternoons")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "evenings"
    }
  }, [_vm._v("evenings")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "any"
    }
  }, [_vm._v("anytime of the day")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h4', [_vm._v("My Specialties Include")]), _vm._v(" "), _c('ul', {
    staticClass: "specialties"
  }, _vm._l((_vm.specialties), function(specialty) {
    return _c('li', [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": specialty
      },
      domProps: {
        "checked": _vm.profile.specialties.indexOf(specialty) > -1,
        "value": specialty
      },
      on: {
        "change": function($event) {
          _vm.setSpecialties(specialty)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": specialty
      }
    }, [_vm._v("\n                            " + _vm._s(_vm._f("deslugify")(specialty)) + "\n                        ")])])
  })), _vm._v(" "), (_vm.profile.nextTermVenue !== 'campus') ? _c('div', [_c('h4', [_vm._v("Student Learning Path(s) Applicable to your Experience:")]), _vm._v(" "), _c('ul', {
    staticClass: "specialties"
  }, _vm._l((_vm.paths), function(path) {
    return _c('li', [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'path_' + path.id
      },
      domProps: {
        "checked": _vm.profile.paths.find(function (p) { return p.id === path.id; }),
        "value": path.name
      },
      on: {
        "change": function($event) {
          _vm.setPaths(path)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'path_' + path.id
      }
    }, [_vm._v("\n                                " + _vm._s(path.name) + "\n                            ")])])
  }))]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Short Bio")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bio),
      expression: "profile.bio"
    }],
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.profile.bio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.bio = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Featured Artwork "), _c('label', {
    staticClass: "file",
    attrs: {
      "for": "featuredImage"
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('input', {
    staticClass: "file",
    attrs: {
      "type": "file",
      "id": "featuredImage"
    },
    on: {
      "change": function($event) {
        _vm.upload('featuredImage', $event.target.files[0])
      }
    }
  }), _vm._v(" "), (_vm.profile.featuredImage) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.profile.featuredImage
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('label', [_vm._v("Demo Reel URL (optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.demoReelUrl),
      expression: "profile.demoReelUrl"
    }],
    staticClass: "demoreel",
    attrs: {
      "placeholder": "http://etc"
    },
    domProps: {
      "value": (_vm.profile.demoReelUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.demoReelUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Image / Work Gallery")]), _vm._v(" "), _c('ul', {
    staticClass: "gallery"
  }, _vm._l((_vm.profile.gallery), function(image, $index) {
    return _c('li', {
      staticClass: "deletable"
    }, [_c('i', {
      staticClass: "fa fa-remove delete",
      on: {
        "click": function($event) {
          _vm.deleteItem('gallery', image, $index)
        }
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": image
      }
    })])
  })), _vm._v(" "), _c('dropzone', {
    ref: "gallery",
    attrs: {
      "id": "gallery",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Credits (Box Art / Posters)")]), _vm._v(" "), _c('ul', {
    staticClass: "gallery"
  }, _vm._l((_vm.profile.credits), function(image, $index) {
    return _c('li', {
      staticClass: "deletable"
    }, [_c('i', {
      staticClass: "fa fa-remove delete",
      on: {
        "click": function($event) {
          _vm.deleteItem('credits', image, $index)
        }
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": image
      }
    })])
  })), _vm._v(" "), _c('dropzone', {
    ref: "credits",
    attrs: {
      "id": "credits",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('h4', [_vm._v("Social Sites")]), _vm._v(" "), _c('ul', {
    staticClass: "social-sites"
  }, _vm._l((_vm.profile.socialSites), function(site, $index) {
    return _c('li', {
      staticClass: "deletable"
    }, [_c('i', {
      staticClass: "fa fa-remove delete",
      on: {
        "click": function($event) {
          _vm.deleteItem('socialSites', site, $index)
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.addProtocol(site.url),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(site.site))])])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialSite.site),
      expression: "socialSite.site"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.socialSite.site = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.socialSites), function(site) {
    return _c('option', {
      domProps: {
        "value": site
      }
    }, [_vm._v(_vm._s(site))])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.socialSite.url),
      expression: "socialSite.url",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "http://etc"
    },
    domProps: {
      "value": (_vm.socialSite.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.socialSite.url = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addSocialSite()
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "students"
  }, [_c('h4', [_vm._v("Past Mentored Students")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.student.name),
      expression: "student.name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.student.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.student.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.student.urls),
      expression: "student.urls",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "student-links",
    attrs: {
      "placeholder": "Links (separated by commas)"
    },
    domProps: {
      "value": (_vm.student.urls)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.student.urls = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "file",
    attrs: {
      "for": "studentAvatar"
    }
  }, [_vm._v("\n                        Avatar\n                    ")]), _vm._v(" "), (_vm.student.avatar) ? _c('img', {
    staticClass: "student-avatar",
    attrs: {
      "src": _vm.student.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "studentAvatar",
    staticClass: "file",
    attrs: {
      "type": "file",
      "id": "studentAvatar"
    },
    on: {
      "change": function($event) {
        _vm.upload('studentAvatar', $event.target.files[0])
      }
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Student's Sample Image(s)")]), _vm._v(" "), _c('dropzone', {
    ref: "studentImages",
    attrs: {
      "id": "studentImages",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addStudent()
      }
    }
  }, [_vm._v("Add Student")]), _vm._v(" "), _c('span', {
    staticClass: "warning"
  }, [_vm._v("When adding previous students, please commit each one before updating your profile by clicking the ‘Add Student’ button first.")])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "mentored-students"
  }, _vm._l((_vm.profile.pastMentoredStudents), function(student, $index) {
    return _c('li', {
      staticClass: "deletable"
    }, [_c('i', {
      staticClass: "fa fa-remove delete",
      on: {
        "click": function($event) {
          _vm.deleteItem('pastMentoredStudents', student, $index)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "student-avatar",
      attrs: {
        "src": student.avatar
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(student.name) + "\n                    ")])
  })), _vm._v(" "), _c('router-link', {
    staticClass: "profile-link",
    attrs: {
      "target": "_blank",
      "to": {
        name: 'mentorProfile',
        params: {
          id: _vm.localStorage.user_id
        }
      }
    }
  }, [_vm._v("\n                    View Profile\n                ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create / Update Profile")])], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-folding-cube"
  }, [_c('div', {
    staticClass: "sk-cube1 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube2 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube4 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube3 sk-cube"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Mentor Selector Profile")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0114ec7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorProfileEditor.vue
// module id = 1936
// module chunks = 2